<!--
================================================
Un composant affichant les initiales d'un utilisateur

* La prop 'color' déterminera la couleur de fond si elle est passée

Url d'accès :
* http://localhost:8080/fr/dunder-mufflin-en/timeTracking (dans l'entête)
* http://localhost:8080/fr/dunder-mufflin-en/reports/detailed/start=2021-07-12/end=2021-07-18?cltArchShow=active&pjctArchShow=active
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <div class="TrigramComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
            <span class="trigram" id="trigram" v-bind:style="{ 'background':' #'+ color }">
              <div class="letters" v-bind:title="$t('initialesX',{'userName':firstname+' '+lastName})" >{{ trigram }}
              </div>
            </span>
  </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'

    export default {
        name: 'TrigramComp', //utile dans vue dev tool
        mixins: [
        ],
        // components: {},

        props: {
            // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
            firstname : String, // prénom de l'utilisateur
            lastName : String, // nom de l'utilisateur
            color : String, // code hexadécimal de la couleur de fond à afficher ex : #00adee (optionnel)
        },
        data: function () {
            return {
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                // user: state => state.user,
                themeToDisplay: state => state.app.themeToDisplay
          }),


            // other computed props :
              trigram: { // 1ère lettre du prénom + 2 premières lettres du nom
                get: function () {
                  return this.lastName != null ? this.firstname.charAt(0) + this.lastName.charAt(0) + this.lastName.charAt(1) : null
                },
              },

        },

        methods: {

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {
        },

    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/

    .TrigramComp{

      //////////////////////////////////////////
      // LIGHT THEME ///////////////////////////
      display: inline-block;

      .trigram {

        $size: 2.5rem;
        border-radius: $size;
        width: $size;
        height: $size;
        background: $brandFourth;
        display: inline-block;

        .letters {
          color: white;
          text-transform: uppercase;
          font-size: 0.8rem;
          font-weight: bold;
          text-align: center;
          margin-top: 0.65rem;
        }

      }

      /////////////////////////////////////////
      // DARK THEME ///////////////////////////
      &.darkMode {

        .trigram {
          background: darken($darkBg,5%);
        }
      }

    }
</style>
